export class Message{
    title: string;
    show_seconds: number = 5;
    type: MessageType = MessageType.ERROR;
}

export enum MessageType{
    ERROR,
    INFO
}


// WEBPACK FOOTER //
// ./src/app/shared/models/message.ts